// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2coIB","head":"Table_head__2ZIT3","col":"Table_col__3UQIe"};